import axios from "axios"

// Create an axios instance with default configurations
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  headers: {
    "Content-Type": "application/json",
  },
  transformResponse: [(data, headers) => {
    // Don't try to transform PDF data
    if (headers['content-type']?.includes('application/pdf')) {
      return data;
    }
    // For other content types, try to parse as JSON
    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }],
})

// Add a request interceptor to add the authorization token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// Add a response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error

    // Handle 401 Unauthorized errors (token expired, invalid, etc.)
    if (response && response.status === 401) {
      localStorage.removeItem("token")
      window.location.href = "/login"
    }

    return Promise.reject(error)
  },
)

export default api
